module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    staticClass: "blue-panel",
    attrs: {
      "title": _vm.product.title
    }
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('panel', [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-1@md img-product"
  }, [_c('img', {
    staticClass: "product-img",
    attrs: {
      "src": _vm.product.images[0]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "l-col-9@md"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-3@md"
  }, [_c('span', [_c('strong', [_vm._v("EAN:")]), _vm._v(" " + _vm._s(_vm.product.ean))])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-3@md"
  }, [_c('span', [_c('strong', [_vm._v("Marca:")]), _vm._v(" " + _vm._s(_vm.product.brand))])]), _vm._v(" "), _vm._l((_vm.product.attributes), function(attribute) {
    return _c('div', {
      key: attribute,
      staticClass: "l-col-3@md"
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(attribute.label) + ":")]), _vm._v(" " + _vm._s(attribute.valor))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "l-col-2@md u-textRight center-vertical"
  }, [_c('button', {
    staticClass: "btn btn--success",
    attrs: {
      "disabled": _vm.product.selectedMatchSku || _vm.newSku
    },
    on: {
      "click": function($event) {
        return _vm.showConfirmSelectMatch()
      }
    }
  }, [_vm._v(_vm._s(_vm.newSku ? 'Selecionado' : 'Considerar como novo'))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-12@md u-textCenter"
  }, [_c('i', {
    staticClass: "icon-arrow icon-arrow-down"
  })]), _vm._v(" "), _c('div', {
    staticClass: "l-col-12@md"
  }, [_c('p', [_c('strong', [_vm._v("Selecione o produto com o match adequado:")])])]), _vm._v(" "), _vm._l((_vm.product.availableMatches), function(availableMatch) {
    return _c('div', {
      key: availableMatch,
      staticClass: "l-col-12@md"
    }, [_c('panel', [_c('div', {
      staticClass: "l-row"
    }, [_c('div', {
      staticClass: "l-col-1@md img-product"
    }, [_c('div', {
      staticClass: "l-col-4@md"
    }, [_c('circle-chart', {
      attrs: {
        "percent": availableMatch.percent,
        "color": _vm.percentColor(availableMatch.percent)
      }
    }, [_vm._v(_vm._s(availableMatch.percent) + "%")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "l-col-2@md u-textCenter"
    }, [_c('img', {
      staticClass: "product-availablematch-img",
      attrs: {
        "src": availableMatch.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "l-col-7@md"
    }, [_c('div', {
      staticClass: "l-row"
    }, [_c('div', {
      staticClass: "l-col-12@md available-title"
    }, [_vm._v(_vm._s(availableMatch.title))]), _vm._v(" "), _c('div', {
      staticClass: "l-col-3@md"
    }, [_c('span', [_c('strong', [_vm._v("EAN:")]), _vm._v(" " + _vm._s(availableMatch.ean))])]), _vm._v(" "), _c('div', {
      staticClass: "l-col-3@md"
    }, [_c('span', [_c('strong', [_vm._v("Marca:")]), _vm._v(" " + _vm._s(availableMatch.brand))])]), _vm._v(" "), _vm._l((availableMatch.attributes), function(attribute) {
      return _c('div', {
        key: attribute,
        staticClass: "l-col-3@md"
      }, [_c('span', [_c('strong', [_vm._v(_vm._s(attribute.label) + ":")]), _vm._v(" " + _vm._s(_vm.formatAttribute(attribute.value)))])])
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "l-col-2@md u-textRight center-vertical"
    }, [_c('button', {
      staticClass: "btn btn--success",
      attrs: {
        "disabled": _vm.product.selectedMatchSku || _vm.newSku
      },
      on: {
        "click": function($event) {
          return _vm.showConfirmSelectMatch(availableMatch)
        }
      }
    }, [_vm._v(_vm._s(availableMatch.sku === _vm.selectedMatch ? 'Selecionado' : 'Selecionar'))])])]), _vm._v(" "), _c('select-match', {
      attrs: {
        "newSku": _vm.newSku
      },
      on: {
        "option": _vm.selectMatch
      },
      model: {
        value: (_vm.selectMatchItemFlag),
        callback: function($$v) {
          _vm.selectMatchItemFlag = $$v
        },
        expression: "selectMatchItemFlag"
      }
    })], 1)], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3531c737","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductMatch/Card.vue
// module id = 3048
// module chunks = 0